module.exports = __webpack_public_path__ + "media/packs/images/search/trade-1a8d73641dbbd65ea824303cadb510f2.svg";